import {Component, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {CreatorSection} from '../../../../models/CreatorModels';
@Component({
    selector: 'app-display',
    templateUrl: './display.component.html',
    styleUrls: ['./display.component.scss']
})
export class DisplayComponent implements OnInit {
    @Input() sections: CreatorSection[];
    @Input() expandedId: number;
    usedSections: CreatorSection[] = [];
    @ViewChild('outlet', {read: ViewContainerRef}) outletRef: ViewContainerRef;
    @ViewChild('content', {read: TemplateRef}) contentRef: TemplateRef<any>;
    editorStylePreview: any;
    displayWidth: number;

    constructor() {
        this.editorStylePreview = {height: '100%;', border: '0px'};
        this.displayWidth = (75 * window.innerWidth) / 100 - 80;
    }

    ngOnInit(): void {
        setInterval(() => this.rerender(), 2000);
    }

    getDirection(section) {
        console.log(section.direction.type);
        return 'end';
    }

    editorCreated($event, value) {
        // this.editorInstance = $event;
        $event.root.innerHTML = value;
    }

    public rerender() {
        this.outletRef.clear();
        this.outletRef.createEmbeddedView(this.contentRef);
    }
}
